export const CONTENT_SETTINGS_MODAL_HEADING_ID = "content-settings-modal-heading";
export const CONTENT_SETTINGS_MODAL_SHOW_BUTTON_TEST_ID = "content-settings-modal-show-button";
export const CONTENT_SETTINGS_MODAL_DELETE_SELECTION_BUTTON_TEST_ID = "content-settings-modal-delete-selection-button";
